import OrderList from '@/components/Order/OrderList'
import OrderDetail from '@/components/Order/OrderDetail'
import AdminOrderList from "./AdminOrderList";
import AdminOrderForm from "./AdminOrderForm";
import AdminOrderDetail from "./AdminOrderDetail";

let OrderRouter = [
    {
        path: '/admin/order',
        name: 'AdminOrderList',
        component: AdminOrderList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/admin/order/new',
        name: 'AdminOrderNew',
        component: AdminOrderForm,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/admin/order/:id/edit',
        name: 'AdminOrderEdit',
        component: AdminOrderForm,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/admin/order/:id',
        name: 'AdminOrderDetail',
        component: AdminOrderDetail,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/order',
        name: 'OrderList',
        component: OrderList
    },
    {
      path: '/order/:id',
      name: 'OrderDetail',
      component: OrderDetail,
}]

export default OrderRouter



// WEBPACK FOOTER //
// ./src/components/Order/router.js